
export default function LocationMap() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Our Location</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Visit our headquarters at Tuscan Gardens Office Park, Noordwyk, Midrand. Strategically located to serve clients across Southern Africa.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="aspect-video w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3584.2!2d28.1048!3d-25.9945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e956e0a1e1e1e1f%3ATuscanGardensOfficePark!2sTuscan%20Gardens%20Office%20Park%2C%20Noordwyk%2C%20Midrand%2C%201685!5e0!3m2!1sen!2sza!4v1700000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="TMI Office Location - Tuscan Gardens Office Park, Noordwyk, Midrand"
              ></iframe>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#800020] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-2-line text-white text-2xl"></i>
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">Strategic Location</h3>
              <p className="text-slate-600 text-sm">
                Based in Midrand, centrally positioned between Johannesburg and Pretoria
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#800020] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-white text-2xl"></i>
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">Easy Access</h3>
              <p className="text-slate-600 text-sm">
                Well-connected to major highways and transportation routes across Gauteng
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#800020] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="font-semibold text-slate-900 mb-2">Modern Facilities</h3>
              <p className="text-slate-600 text-sm">
                Professional office space at Tuscan Gardens Office Park, Noordwyk
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
